import * as React from "react";
import "./Error.scss";

const error = (props: { error: boolean }) =>
  props.error ? (
    <div className="Error-container">
      <p>Unable to load page.</p>
      <p>Please, try again later.</p>
    </div>
  ) : null;

export default error;



// WEBPACK FOOTER //
// ./src/components/Error.tsx